import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { api } from '../lib/api';
import { useAuth } from '../lib/auth';

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash || window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav('/login'); return; }
    const sid = decodeURIComponent(m[1]);
    (async () => {
      try {
        await api.post('/auth/session', {}, { headers: { 'X-Session-ID': sid } });
        // Clear hash
        window.history.replaceState(null, '', window.location.pathname);
        await refresh();
        nav('/');
      } catch {
        nav('/login');
      }
    })();
  }, [location, nav, refresh]);

  return (
    <div className="min-h-screen grid place-items-center">
      <div className="text-slate-400">Signing you in…</div>
    </div>
  );
}
